// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_jb-0";
export var buttonContainer = "_jb-3";
export var cancelButton = "_jb-4";
export var headerSection = "_jb-6";
export var headerTitle = "_jb-9";
export var messageSideLeft = "_jb-1";
export var messageSideRight = "_jb-2";
export var orderNumberContainer = "_jb-7";
export var orderNumberLabel = "_jb-8";
export var submitButton = "_jb-5";